/* --- File: src/firebaseConfig.js --- */
import { initializeApp } from "firebase/app";
import { 
    initializeFirestore, 
    persistentLocalCache, 
    persistentMultipleTabManager 
} from "firebase/firestore"; 
import { getAuth } from "firebase/auth"; 
import { getStorage } from "firebase/storage"; 

// [QUAN TRỌNG] Thêm chữ "export" vào dòng dưới đây để các trang khác dùng được
export const firebaseConfig = {
  apiKey: "AIzaSyAtRMg7DhhmvMnOfNJIVI_cx8MpVWMNreg",
  authDomain: "student-management-fireb-a3829.firebaseapp.com",
  projectId: "student-management-fireb-a3829",
  storageBucket: "student-management-fireb-a3829.firebasestorage.app",
  messagingSenderId: "70150607521",
  appId: "1:70150607521:web:2e2d94f4632d55258e16e0",
  measurementId: "G-QWGSLRCN87"
};

// 1. Khởi tạo App
const app = initializeApp(firebaseConfig);

// 2. Khởi tạo Firestore (Database) với Cache
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager() 
  })
});

// 3. Khởi tạo Auth
export const auth = getAuth(app);

// 4. Khởi tạo Storage
export const storage = getStorage(app);

export default app;